export const modeSimplified = 'mode-simplified'
export const modeGraphical = 'mode-graphical'
export const modeProgressive = 'mode-progressive'
